(() => {
  const facets = document.querySelector('facet-filters-form.collection-facets');
  if (!facets) return;

  let ticking = false;

  const syncStickyState = () => {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const facetsTop = Math.round(facets.getBoundingClientRect().top);

    // Only treat as stuck when we've scrolled and the bar is pinned to the top.
    // Prevents hiding the header on first paint / refresh at the top of the page.
    const menuOpen = Boolean(document.querySelector('.header.menu-open'));
    const isSticky = !menuOpen && scrollY > 0 && facetsTop <= 0;

    document.body.classList.toggle('collection-facets-is-sticky', isSticky);
    facets.classList.toggle('is-sticky', isSticky);
  };

  const scrollPageToTopIfSticky = () => {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const facetsEl = document.querySelector('facet-filters-form.collection-facets');
    if (!facetsEl) return;

    const facetsTop = Math.round(facetsEl.getBoundingClientRect().top);
    if (scrollY > 0 && facetsTop <= 0) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      syncStickyState();
      ticking = false;
    });
  };

  // Scroll back to top only after filter / sort / view / category updates finish.
  document.addEventListener('collection-facets:updated', scrollPageToTopIfSticky);

  syncStickyState();
  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize, { passive: true });
})();
